export default __webpack_public_path__ + "static/media/news2img3.8806d014.png";